module.exports = __webpack_public_path__ + "cbcf93b0708499335ec75c90f45e9246.svg";